import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@services/local-storage.service';
import { SequencePreviewMode } from '@shared/models/enums/sequence-preview-mode.enum';

@Injectable({
  providedIn: 'root',
})
export class SequencePreviewModeService {
  private readonly localStorageService = inject(LocalStorageService);

  setPreviewMode(mode: SequencePreviewMode): void {
    this.localStorageService.set('sequencePreviewMode', mode.toString());
  }

  getPreviewMode(): SequencePreviewMode {
    const savedMode = this.localStorageService.get('sequencePreviewMode');
    return savedMode ? (Number(savedMode) as SequencePreviewMode) : SequencePreviewMode.ROW;
  }
}
